<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <router-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown': !isNest}">
          <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </router-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item
        v-for="(child, idx) in item.children"
        :key="sidebarChildKey(child, idx)"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import Item from './Item'

export default {
  name: 'SidebarItem',
  components: { Item },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {}
  },
  methods: {
    /** 避免兄弟节点 path 相同（如多个 `info`）导致 Vue duplicate key */
    sidebarChildKey(child, idx) {
      const p = this.item.path != null ? String(this.item.path) : ''
      const c = child && child.path != null ? String(child.path) : ''
      const n = child && child.name != null ? String(child.name) : ''
      return `${p}::${c}::${n}::${idx}`
    },
    hasOneShowingChild(children = [], parent) {
      if (children && children.length < 1) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      } else if (children.length > 0) {
        if (parent.length > 0) {
          const showingChildren = children.filter(item => {
            if (item.hidden) {
              return false
            } else {
              // Temp set(will be used if only has one showing child)
              this.onlyOneChild = item
              return true
            }
          })
          // When there is only one child router, the child router is displayed by default
          if (showingChildren.length === 1) {
            return true
          }

          // Show parent if there are no child router to display
          if (showingChildren.length === 0) {
            this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }

            return true
          }
        }
      //   const showingChildren = children.filter(item => {
      //   if (item.hidden) {
      //     return false
      //   } else {
      //     // Temp set(will be used if only has one showing child)
      //     this.onlyOneChild = item
      //     return true
      //   }
      // })
      // console.log(showingChildren)
      // // When there is only one child router, the child router is displayed by default
      // if (showingChildren.length === 1) {
      //   return true
      // }

      // // Show parent if there are no child router to display
      // if (showingChildren.length === 0) {
      //   
      
      //   return true
      // }

      }else{
        return false
      }
     
      
    },
    resolvePath(routePath) {
      const currentRoutes = this.$store.state.route.currentRoutes
      if (currentRoutes && currentRoutes.path) {
        return path.resolve(currentRoutes.path, this.basePath, routePath)
      }
    }
  }
}
</script>
<style scoped lang="scss">
  a{
    text-decoration: none;
  }
</style>
